import React, { createContext, useCallback } from 'react'
import { useAuth } from 'oidc-react'
import { gzip } from 'pako'

const defaultOptions = {
    cache: 'default',
    headers: {
        'Cache-Control': 'max-age=3600',
    }
}

const APIRequestContext = createContext(null)

const APIRequestContextProvider = ({ children }) => {
    const { userManager } = useAuth()

    const authenticatedFetch = useCallback(async (endpoint, options) => {
        const u = await userManager.getUser()
        let fetchOptions = {}
        const authorizationHeader = u ? {
            Authorization: `Bearer ${u.access_token}`,
        } : {}
        if (options) {
            if (options.method === 'POST' || options.method === 'PUT') {

                try {
                    options.body = gzip(options.body)
                    options.headers['Content-Encoding'] = 'gzip'
                } catch (e) {
                    console.error('Failed to gzip request body', e)
                }
            }
            fetchOptions = {
                ...defaultOptions,
                ...options,
                headers: {
                    ...defaultOptions.headers,
                    ...options.headers,
                    ...authorizationHeader
                },
            }
            console.log('fetchOptions:', fetchOptions)
        } else {
            fetchOptions = {
                method: 'GET',
                ...defaultOptions,
                headers: {
                    ...defaultOptions.headers,
                    ...authorizationHeader
                },
            }
        }
        return fetch(endpoint, fetchOptions)
    }, [userManager])

    return (
        <APIRequestContext.Provider
            value={{authenticatedFetch}}
        >
            {children}
        </APIRequestContext.Provider>
    )
}

export { APIRequestContext }
export default APIRequestContextProvider
